import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Segmented,
  Space,
  notification,
  Divider,
  Checkbox,
  Modal,
  message,
  Radio,
  Drawer,
  Tag,
  Spin,
} from "antd";
import { CloseOutlined, TagOutlined } from "@ant-design/icons";
import locale from "antd/es/date-picker/locale/vi_VN";
import dayjs from "dayjs";
import moment from "moment";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import $axios from "../../services/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CryptoJS from "crypto-js";
import {
  faShuffle,
  faPlus,
  faArrowAltCircleRight,
  faMinus,
  faRoad,
  faPlane,
  faUser,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import TypeOfCarJson from "../../data-test/type-of-car.json";
import PriceJson from "../../data-test/price.json";
import Autocomplete from "react-google-autocomplete";
import axios from "axios";
import _, { add } from "lodash";

// https://maps.googleapis.com/maps/api/place/autocomplete/json?input='.$_GET['keyword'].'&language=vi&components=country:vn&location=21.0285,105.8542&types=geocode|establishment&radius=50000&key='.GOOGLE_DISTANCE_API_KEY

const generateSignature = (url, secretKey) => {
  const params = new URLSearchParams(url.split("?")[1]);
  const sortedParams = Array.from(params.entries())
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .map(([key, value]) => value || ""); // Chỉ lấy giá trị, xử lý giá trị rỗng

  sortedParams.push(secretKey);

  // Tạo plaintext bằng cách nối các tham số
  const plaintext = sortedParams.join("|");

  // Tính toán chữ ký SHA-256
  const signature = CryptoJS.SHA256(plaintext).toString(CryptoJS.enc.Hex);

  return signature;
};

const GoongAutocomplete = ({
  value,
  onChange,
  onPlaceSelected,
  error,
  disabled,
  placeholder,
  iconComponent,
}) => {
  const [suggestions, setSuggestions] = useState([]);

  const fetchSuggestions = async (inputValue) => {
    if (inputValue && inputValue.length > 2) {
      try {
        const response = await axios.get(
          `https://rsapi.goong.io/Place/AutoComplete`,
          {
            params: {
              input: inputValue,
              api_key: process.env.REACT_APP_GOOGNG_API_KEY,
              radius: 50,
            },
          }
        );
        setSuggestions(response.data.predictions || []);
      } catch (error) {
        console.error("Error fetching Goong places:", error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const debouncedFetchSuggestions = useCallback(
    _.throttle(fetchSuggestions, 1000),
    []
  );

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);
    debouncedFetchSuggestions(inputValue);
  };

  const handleSelectPlace = async (place) => {
    setSuggestions([]);
    try {
      const response = await axios.get(`https://rsapi.goong.io/Place/Detail`, {
        params: {
          place_id: place.place_id,
          api_key: process.env.REACT_APP_GOOGNG_API_KEY,
        },
      });
      onChange(place.description);
      onPlaceSelected(response.data.result);
    } catch (error) {
      console.error("Error fetching place details:", error);
    }
  };

  return (
    <div className="autocomplete-container">
      {iconComponent}
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        className={`autocomplete-input ${error ? "border-error" : ""
          } h-[48px] text-[16px]`}
        disabled={disabled}
        placeholder={placeholder}
      />
      {suggestions.length > 0 && (
        <ul className="autocomplete-suggestions">
          {suggestions.map((place) => (
            <li key={place.place_id} onClick={() => handleSelectPlace(place)}>
              {place.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const Booking = ({ setLoading, loading, setStep }) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [typeTrip, setTypeTrip] = useState("plane");
  const history = useHistory();
  const [voucherTxt, setVoucherTxt] = useState("");
  const [typesCar, setTypesCar] = useState([]);
  const [prices, setPrices] = useState(0);
  const [priceSelected, setPriceSelected] = useState(0);
  const [addStart, setAddStart] = useState("");
  const [totalStopAddress, setTotalStopAddress] = useState(0);
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [addPrice, setAddPrice] = useState(0);
  const [addEnd, setAddEnd] = useState(
    typeTrip === "plane" ? "Sân bay Nội bài" : ""
  );
  const [addStop1, setAddStop1] = useState("");
  const [addStop2, setAddStop2] = useState("");
  const [carSelected, setCarSelected] = useState("");
  const [errors, setErrors] = useState({
    addStart: false,
    addEnd: false,
  });
  const [isModalHasPriceOpen, setIsModalHasPriceOpen] = useState(false);
  const [isModalNoPriceOpen, setIsModalNoPriceOpen] = useState(false);
  const [form] = Form.useForm();
  const [formContact] = Form.useForm();
  const [disabledField, setDisabledField] = useState("addEnd");

  // Voucher states
  const [openVoucher, setOpenVoucher] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [loadingVouchers, setLoadingVouchers] = useState(false);
  const [manualVoucherCode, setManualVoucherCode] = useState("");
  const [loadingManualVoucher, setLoadingManualVoucher] = useState(false);

  useEffect(() => {
    getTypesCar();
    getAddPrice();
    getVouchers();
  }, []);

  const getVouchers = async () => {
    setLoadingVouchers(true);
    try {
      const res = await $axios.$get("/voucher/vouchers");
      const list = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];

      const now = moment();
      const validVouchers = list.filter((voucher) => {
        if (voucher.status !== undefined && voucher.status !== 1) return false;
        if (voucher.expiredAt && now.isAfter(moment(voucher.expiredAt)))
          return false;
        return Number(voucher.amount) > 0;
      });
      setVouchers(validVouchers);
    } catch (error) {
      console.error("Lỗi khi tải danh sách voucher:", error);
    } finally {
      setLoadingVouchers(false);
    }
  };

  const handleClearVoucher = () => {
    setPriceSelected((prev) => prev + voucherValue);
    setVoucherValue(0);
    setVoucherCode("");
    setManualVoucherCode("");
    setVoucherTxt("");
  };

  const applyVoucherPick = (voucher) => {
    if (!voucher) return;
    const code = voucher.code || "";
    const amount = Number(voucher.amount) || 0;

    if (amount > 0) {
      setPriceSelected((prev) => Math.max(0, prev + voucherValue - amount));
      setVoucherValue(amount);
      setVoucherCode(code);
      setManualVoucherCode(code);
      setVoucherTxt(
        `<div class="text-[14px]">Áp dụng mã giảm giá thành công! <span class="text-green-600 font-bold text-[15px]">-${amount.toLocaleString(
          "vi-VN"
        )} đ</span></div>`
      );
      notification.success({
        message: "Áp dụng thành công",
        description: `Mã ${code} giảm ${amount.toLocaleString("vi-VN")} đ`,
      });
      setOpenVoucher(false);
    } else {
      const errMsg =
        voucher?.message ||
        (voucher.status === 0
          ? "Mã giảm giá đã hết hạn hoặc không còn hiệu lực!"
          : "Mã giảm giá không hợp lệ!");
      setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
      notification.error({
        message: "Không hợp lệ",
        description: errMsg,
      });
      handleClearVoucher();
    }
  };

  const applyManualVoucher = async (e) => {
    const code = (
      typeof e === "string" && e.trim() ? e : manualVoucherCode
    ).trim();
    if (!code) {
      setVoucherTxt(
        `<div class="text-[14px] text-red-600">Vui lòng nhập mã giảm giá!</div>`
      );
      return;
    }

    setLoadingManualVoucher(true);
    try {
      const res = await $axios.$get(
        `/voucher/getVoucher?voucherCode=${encodeURIComponent(code)}`
      );

      const voucherData = res?.data?.data || res?.data;
      if (
        voucherData &&
        (voucherData.status === undefined || voucherData.status === 1) &&
        Number(voucherData.amount) > 0
      ) {
        applyVoucherPick({ ...voucherData, code: voucherData.code || code });
      } else {
        const errMsg =
          voucherData?.message ||
          res?.data?.message ||
          res?.message ||
          "Mã giảm giá không tồn tại hoặc đã hết hạn!";
        setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
        notification.error({
          message: "Không hợp lệ",
          description: errMsg,
        });
        handleClearVoucher();
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || "Mã giảm giá không hợp lệ!";
      setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
      notification.error({
        message: "Không hợp lệ",
        description: errMsg,
      });
      handleClearVoucher();
    } finally {
      setLoadingManualVoucher(false);
    }
  };

  const handleFinishContact = async (values) => {
    setLoading(true);
    const pickupTime = `${dayjs(form.getFieldValue("departDate")).format(
      "YYYY-MM-DD HH:mm"
    )}`;
    const finalAmount = priceSelected || 0;

    const body = {
      StartPoint: addStart,
      EndPoint: addEnd,
      Roundtrip: 0,
      Vat: form.getFieldValue("VAT") ? 1 : 0,
      YourName: values.fullName,
      YourPhone: values.phone,
      Ngaydatxe: pickupTime,
      LoaiXe: carSelected,
      price: finalAmount,
    };

    try {
      const res = await $axios.$post(`/taxi/sendBooking`, body);
      const bodyPayment = {
        PickupAddress: _.get(res, "data.data.pickup_address", ""),
        DestinationAddress: _.get(res, "data.data.destination_address", ""),
        RoundTrip: 0,
        IsHaveBill: _.get(res, "data.data.is_have_bill", false),
        CustomerName: _.get(res, "data.data.customer_name", false),
        CustomerPhone: _.get(res, "data.data.customer_phone", ""),
        PickupTime: dayjs(form.getFieldValue("departDate")).format(
          "DD/MM/YYYY HH:mm:ss"
        ),
        TypeOfCar: _.get(res, "data.data.type_of_car", ""),
        TypeOfCarName: carSelected,
        PriceCustomer: _.get(res, "data.data.price_customer", 0),
        Amount: finalAmount,
        AmountOriginal: finalAmount + voucherValue,
        AmountDiscount: voucherValue || 0,
        VoucherCode: voucherCode || "",
        Note: "",
        Type: _.get(res, "data.data.type", null),
        Id: _.get(res, "data.data.id", null),
        Status: _.get(res, "data.data.status", ""),
        VatCompany: "",
        VatFullName: values?.VatFullName || "",
        VatMst: values?.VatMst || "",
        VatEmail: values?.VatEmail || "",
      };
      bodyPayment.InfoOrder = JSON.stringify({
        Amount: finalAmount,
        PickupAddress: bodyPayment.PickupAddress,
        DestinationAddress: bodyPayment.DestinationAddress,
        PickupTime: bodyPayment.PickupTime,
        Service: "airportbus",
        Sponsor: "IPASS",
        VoucherCode: voucherCode || "",
        VoucherValue: voucherValue || 0,
      });
      const resPayment = await $axios.post(
        "/payment/paymentRequired",
        bodyPayment
      );
      if (resPayment.data.data.orderId) {
        // window.location.href = resPayment.data.data.paymentUrl;
        setLoading(true);
        try {
          if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.NativeJavascriptInterface
          ) {
            // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
            window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
              orderCode: resPayment.data.data.orderId,
            });
          } else {
            console.error(
              "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
            );
          }
          // Send orderCode for Android
          if (window.webkit !== undefined) {
            if (window.webkit.messageHandlers.appInterface !== undefined) {
              window.webkit.messageHandlers.appInterface.postMessage(
                JSON.stringify({
                  orderCode: resPayment.data.data.orderId,
                })
              );
            }
          }
          if (window.appInterface !== undefined) {
            window.appInterface.postMessage(
              JSON.stringify({
                orderCode: resPayment.data.data.orderId,
              })
            );
          }
        } catch (error) {
          message.error(error.response.data.message);
        } finally {
          setLoading(false);
        }
      } else {
        notification.error({
          status: "error",
          message: "Thất bại",
          description: "Đã có lỗi xảy ra! Vui lòng đặt chuyến khác",
        });
      }
    } catch (error) {
      notification.error({
        status: "error",
        message: "Thất bại",
        description: error.response.data.message || "Đã có lỗi xảy ra! Vui lòng đặt chuyến khác",
      });
    }
  };

  const handleFinish = async (values) => {
    if (!addStart || !addEnd) {
      setErrors({
        ...errors,
        addStart: !addStart,
        addEnd: !addEnd,
      });
      return;
    }
    setLoading(true);
    try {
      //  Sân bay : schedule = 0,1,2
      // - Nội thành ra sân bay = 0
      // - Sân bay về nội thành = 2
      // - Nội thành ra sân bay nhưng chọn khứ hồi = 1
      // Đường dài : schedule = 3,4
      // - Đường dài không khứ hồi = 3
      // - Đường dài có khứ hồi = 4
      // let schedule = 0;
      // if (typeTrip === "road") {
      //   schedule = form.getFieldValue("roundtrip") ? 4 : 3;
      // } else {
      //   schedule =
      //     disabledField === "addStart"
      //       ? 2
      //       : form.getFieldValue("roundtrip")
      //       ? 1
      //       : 0;
      // }
      let schedule = 0;
      if (typeTrip === "road") {
        schedule = 3;
      } else {
        schedule = disabledField === "addStart" ? 2 : 0;
      }
      const pickupTime = `${dayjs(values.departDate).format(
        "YYYY-MM-DD HH:mm"
      )}`;
      const res = await $axios.$get(
        `/taxi/getPrice?surcharge=${addPrice}&pickupTime=${pickupTime}&schedule=${schedule}&addressStart=${addStart}&addressEnd=${addEnd}&vat=${values.VAT ? 1 : 0
        }&token=xevipnoibai`
      );
      setPrices(res.data.data);
      const _typeCar = typesCar.filter((car) => res.data.data[car.value]);
      setTypesCar(_typeCar);
      setPriceSelected(
        res.data.data[_typeCar[0].value].price + addPrice - voucherValue
      );
      setCarSelected(_typeCar[0].text);
      setTimeout(() => {
        setIsModalHasPriceOpen(true);
      }, 0);
    } catch (error) {
      setIsModalNoPriceOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSwap = () => {
    setAddStart(addEnd);
    setAddEnd(addStart);
    if (typeTrip === "plane") {
      setDisabledField(disabledField === "addStart" ? "addEnd" : "addStart");
    }
  };

  const handleValuesFormChange = (changedValues, allValues) => {
    // console.log(allValues, "allValues");
  };

  const getAddPrice = async () => {
    setLoading(true);
    try {
      const res = await $axios.$get(`/payment/getAddPrice`);
      if (res.data.data.data.status === 1) {
        setAddPrice(_.get(res, "data.data.data.amount", 0));
        console.log(_.get(res, "data.data.data.amount", 0), "222");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getTypesCar = async () => {
    setLoading(true);
    try {
      const response = await $axios.$get(`/taxi/listTypeOfCar`);
      setTypesCar(
        response.data.data.filter((car) => {
          return ["Xe 4 chỗ", "Xe 5 chỗ", "Xe 7 chỗ", "Xe 16 chỗ"].includes(
            car.text
          );
        })
      );
    } catch (error) {
      notification.error({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalHasPriceOpen(false);
    handleClearVoucher();
  };

  return (
    <div className="flex flex-col items-center mt-[0px] step1 booking relative top-[100px]">
      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        onValuesChange={handleValuesFormChange}
        initialValues={{
          departDate: dayjs(),
        }}
        onFinishFailed={(values) => {
          setErrors({
            ...errors,
            addStart: !addStart,
            addEnd: !addEnd,
          });
        }}
        className="form-search w-[92%] mb-4"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-accent"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 rounded-2xl"
          >
            <div className="flex justify-between items-center w-full gap-2">
              <div className="text-[16px] text-primary font-semibold">
                Đặt xe
              </div>
              <Form.Item name="type" className="mb-0 flex-1">
                <Radio.Group
                  block
                  size="large"
                  onChange={(e) => {
                    setTypeTrip(e.target.value);
                    if (e.target.value === "plane") {
                      setDisabledField("addEnd");
                      setAddEnd("Sân bay Nội bài");
                    }
                  }}
                  options={[
                    {
                      label: (
                        <div className="flex items-center gap-2 w-full">
                          {typeTrip === "plane" ? (
                            <img
                              src="/images/ic-plane-active.svg"
                              alt=""
                              className="w-[16px]"
                            />
                          ) : (
                            <img
                              src="/images/ic-plane.svg"
                              alt=""
                              className="w-[16px]"
                            />
                          )}
                          <div>Đi sân bay</div>
                        </div>
                      ),
                      value: "plane",
                    },
                    {
                      label: (
                        <div className="flex items-center w-full gap-2">
                          {typeTrip !== "plane" ? (
                            <img
                              src="/images/ic-road-active.svg"
                              alt=""
                              className="w-[16px]"
                            />
                          ) : (
                            <img
                              src="/images/ic-road.svg"
                              alt=""
                              className="w-[16px]"
                            />
                          )}
                          <span>Đi đường dài</span>
                        </div>
                      ),
                      value: "road",
                    },
                  ]}
                  defaultValue="plane"
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
            </div>
            <div className="flex gap-4 justify-between w-full items-center">
              <div className="flex-1">
                <Space.Compact
                  className="w-full mt-5"
                  direction="horizontal"
                  block={true}
                >
                  <div className="add-start-container">
                    <GoongAutocomplete
                      value={addStart}
                      onChange={(value) => setAddStart(value)}
                      placeholder="Nhập điểm đón"
                      error={errors.addStart}
                      disabled={
                        typeTrip === "plane" && disabledField === "addStart"
                          ? true
                          : false
                      }
                      onPlaceSelected={(place) => {
                        setAddStart(place.formatted_address);
                        setErrors({ ...errors, addStart: false });
                      }}
                      iconComponent={
                        <svg
                          className="absolute top-[30%] left-2 text-primary"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.49997 13.3845C11.0931 13.3845 12.3846 12.093 12.3846 10.4998C12.3846 8.90672 11.0931 7.61523 9.49997 7.61523C7.90684 7.61523 6.61536 8.90672 6.61536 10.4998C6.61536 12.093 7.90684 13.3845 9.49997 13.3845Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <circle
                            cx="9.5"
                            cy="10.5"
                            r="6.75"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                        </svg>
                      }
                    />
                  </div>
                </Space.Compact>
                {errors.addStart && (
                  <div className="text-[14px] text-[#ff4d4f] self-start">
                    Vui lòng nhập dữ liệu điểm đi!
                  </div>
                )}
                {Array.from({ length: totalStopAddress }, (item, index) => (
                  <Space.Compact
                    className="w-full mt-3"
                    direction="horizontal"
                    block={true}
                  >
                    <div className="add-stop-container">
                      <GoongAutocomplete
                        placeholder="Nhập điểm đến"
                        onPlaceSelected={(place) => {
                          if (index === 1) {
                            setAddStop1(place.formatted_address);
                          } else {
                            setAddStop2(place.formatted_address);
                          }
                        }}
                      />
                    </div>
                    <Button
                      type="primary"
                      size="large"
                      className="bg-primary"
                      onClick={() => {
                        setTotalStopAddress((prev) => prev - 1);
                      }}
                    >
                      {" "}
                      <FontAwesomeIcon icon={faMinus} color="white" />
                    </Button>
                  </Space.Compact>
                ))}
                <Space.Compact
                  className="w-full mt-5"
                  direction="horizontal"
                  block={true}
                >
                  <div className="add-end-container">
                    <GoongAutocomplete
                      value={addEnd}
                      onChange={(value) => setAddEnd(value)}
                      placeholder="Điểm đến"
                      error={errors.addEnd}
                      disabled={
                        typeTrip === "plane" && disabledField === "addEnd"
                          ? true
                          : false
                      }
                      onPlaceSelected={(place) => {
                        setAddEnd(place.formatted_address);
                        setErrors({ ...errors, addEnd: false });
                      }}
                      iconComponent={
                        <svg
                          className="absolute top-[30%] left-2 text-primary"
                          width="16"
                          height="20"
                          viewBox="0 0 16 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.875 7.52969C14.875 12.1875 8 19.0625 8 19.0625C8 19.0625 1.125 12.1875 1.125 7.52969C1.125 3.16031 4.67781 0.625 8 0.625C11.3222 0.625 14.875 3.16031 14.875 7.52969Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </svg>
                      }
                    />
                  </div>
                </Space.Compact>
                {errors.addEnd && (
                  <div className="text-[14px] text-[#ff4d4f] self-start">
                    Vui lòng nhập dữ liệu điểm đến!
                  </div>
                )}
              </div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="cursor-pointer text-primary"
                onClick={() => handleSwap()}
              >
                <circle
                  cx="16"
                  cy="16"
                  r="15.5"
                  fill="white"
                  stroke="currentColor"
                />
                <path
                  d="M17.0678 13.5192C16.7798 13.2312 16.7797 12.7641 17.0678 12.476L20.1842 9.35893C20.4722 9.07084 20.9393 9.07077 21.2274 9.35883L17.0678 13.5192ZM17.0678 13.5192C17.3559 13.8073 17.823 13.8072 18.111 13.5191L19.9684 11.6613L19.9695 22.3477C19.9696 22.755 20.2999 23.0853 20.7072 23.0852C21.1146 23.0852 21.4448 22.7549 21.4448 22.3475L21.4437 11.6612L23.3014 13.5185C23.5895 13.8066 24.0566 13.8065 24.3446 13.5184C24.4886 13.3744 24.5606 13.1854 24.5606 12.9968C24.5606 12.8082 24.4885 12.6192 24.3445 12.4753L21.2274 9.35883L17.0678 13.5192Z"
                  fill="currentColor"
                />
                <path
                  d="M15.4928 18.7088C15.7808 18.9968 15.7809 19.4639 15.4928 19.752L12.3764 22.8691C12.0884 23.1572 11.6213 23.1573 11.3332 22.8692L15.4928 18.7088ZM15.4928 18.7088C15.2047 18.4207 14.7376 18.4208 14.4496 18.7089L12.5922 20.5667L12.5911 9.8803C12.591 9.47299 12.2607 9.1427 11.8534 9.14282C11.446 9.14282 11.1158 9.4731 11.1158 9.88053L11.1169 20.5668L9.25917 18.7095C8.9711 18.4215 8.50402 18.4215 8.21598 18.7096C8.07202 18.8536 7.99998 19.0426 8 19.2312C8.00002 19.4198 8.0721 19.6088 8.21614 19.7527L11.3332 22.8692L15.4928 18.7088Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <Row
              align={"middle"}
              justify={"space-between"}
              className="my-4 w-full"
            >
              {/* <Col span={8}>
              <Form.Item
                name="roundtrip"
                className="mb-0"
                valuePropName="checked"
              >
                <Checkbox size="large">Khứ hồi</Checkbox>
              </Form.Item>
            </Col> */}
              <Col span={24}>
                <Form.Item name="VAT" className="mb-0" valuePropName="checked">
                  <Checkbox size="large">VAT</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn ngày đi!",
                },
              ]}
              name={"departDate"}
              className="w-full mb-4"
            >
              <DatePicker
                className="w-full h-[48px] text-[16px]"
                size="large"
                showTime={{
                  format: "HH",
                  minuteStep: 60,
                  defaultValue: dayjs("00:00", "HH"),
                }} // Cấu hình chỉ hiển thị giờ và phút
                placeholder="Chọn ngày"
                format="DD/MM/YYYY HH:mm"
                minDate={dayjs()}
                allowClear={false}
                locale={locale} // Thiết lập locale tiếng Việt
                suffixIcon={
                  <svg
                    className="text-primary"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_120_8739)">
                      <path
                        d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_120_8739">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="sumit"
              loading={loading}
              style={{ height: 48 }}
              className="mb-4 w-full bg-primary mt-[32px]"
            >
              <span className="text-[18px] font-bold">Đặt xe</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => history.push("/history?tab=2")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
      </Form>
      <div className="text-center my-4">
        <span className="text-[#808080] font-normal">
          Hotline hỗ trợ khách hàng{" "}
        </span>
        <a href="tel:1900255585" className="font-bold text-primary text-[16px]">
          1900255585
        </a>
      </div>

      <Modal
        title={
          <div className="text-primary text-[20px] font-bold">
            Xác nhận thông tin
          </div>
        }
        open={isModalHasPriceOpen}
        onCancel={handleCancel}
        footer={null}
        style={{ top: 0, padding: 0 }}
        width="100vw"
        bodyStyle={{
          padding: 0,
          margin: 0,
          overflow: "hidden",
        }}
        centered={!form.getFieldValue("VAT")}
      >
        <div className="text-[14px]">
          Giá cước đã bao gồm phí ra, vào sân bay Nội Bài, chưa bao gồm phí cầu
          đường khác.
        </div>
        <div className="flex justify-between flex-wrap my-3">
          {typesCar.map((car) => (
            <div
              key={car.value}
              className="flex gap-4 w-1/2 mb-3 cursor-pointer"
              onClick={() => {
                setCarSelected(car.text);
                setPriceSelected(
                  prices[car.value.toString()]?.price + addPrice - voucherValue
                );
              }}
            >
              <img
                className={
                  carSelected === car.text
                    ? "car-selected border-primary border-[4px] border-solid"
                    : "car-not-selected"
                }
                src={
                  car.text === "Xe 4 chỗ"
                    ? "/images/4seat.webp"
                    : car.text === "Xe 5 chỗ"
                      ? "/images/5seat.webp"
                      : car.text === "Xe 7 chỗ"
                        ? "/images/7seat.webp"
                        : "/images/16seat.webp"
                }
                alt=""
                width={50}
              />
              <div className="flex flex-col">
                <div>{car.text}</div>
                <div className="text-[16px] font-semibold text-primary">
                  {(
                    prices[car.value.toString()]?.price +
                    addPrice -
                    voucherValue
                  ).toLocaleString("vi-VN")}{" "}
                  đ
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center text-yellow-500">
          Đặt xe sớm để được ưu đãi tốt nhất!
        </div>
        <Divider
          variant="dashed"
          style={{ borderColor: "#0064D2" }}
          dashed
          className="my-3 py-0"
        />
        <Form
          form={formContact}
          onFinish={handleFinishContact}
          layout="vertical"
          onFinishFailed={(values) => { }}
          className="w-full"
          initialValues={{
            fullName: userInfo ? userInfo?.fullName : "",
            phone: userInfo ? userInfo?.phone : "",
          }}
        >
          <div className="text-primary self-start text-[16px] my-2 font-semibold">
            Thông tin của bạn
          </div>
          <div className="w-full">
            <Form.Item
              name="fullName"
              label="Họ và tên"
              rules={[
                {
                  required: true,
                  message: "Họ và tên không được để trống",
                },
              ]}
              className="mb-3 w-full"
            >
              <Input
                size="large"
                prefix={
                  <FontAwesomeIcon icon={faUser} className="text-primary" />
                }
                placeholder="Họ và tên"
              />
            </Form.Item>
          </div>
          <Form.Item
            name="phone"
            label="Số điện thoại"
            rules={[
              {
                required: true,
                message: "Số điện thoại không được để trống",
              },
              {
                pattern: /^(03|05|07|08|09)\d{8}$|^\+84\d{9}$/,
                message: "Số điện thoại không hợp lệ",
              },
            ]}
            className="mb-5 w-full"
          >
            <Input
              size="large"
              prefix={
                <FontAwesomeIcon icon={faPhone} className="text-primary" />
              }
              placeholder="Nhập số điện thoại..."
            />
          </Form.Item>
          {form.getFieldValue("VAT") && (
            <>
              <div className="text-primary self-start text-[16px] my-2 font-semibold">
                Thông tin xuất hoá đơn
              </div>
              <Form.Item
                name="VatMst"
                className="mb-3"
                label={<div className="text-[14px]">Mã số thuế (VAT)</div>}
                rules={[
                  {
                    required: true,
                    message: "Mã số thuế không được để trống",
                  },
                ]}
              >
                <Input size="large" placeholder="Mã số thuế" />
              </Form.Item>
              <Form.Item
                label={<div className="text-[14px]">Người nhận hoá đơn</div>}
                name="VatFullName"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Người nhận hoá đơn không được để trống",
                  },
                ]}
              >
                <Input size="large" placeholder="Nhập người nhận hoá đơn" />
              </Form.Item>
              <Form.Item
                label="Email"
                name="VatEmail"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Email không được để trống",
                  },
                  {
                    type: "email",
                    message: "Vui lòng nhập email đúng định dạng",
                  },
                ]}
              >
                <Input size="large" placeholder="Nhập Email" />
              </Form.Item>
            </>
          )}
          <div className="my-3 p-3 bg-gray-50 rounded-xl border border-gray-200 flex flex-col gap-2">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium text-gray-700">Mã khuyến mãi</span>
              <div className="flex items-center gap-1">
                <Tag
                  onClick={() => setOpenVoucher(true)}
                  color={!voucherCode && !voucherValue ? "default" : "success"}
                  icon={<TagOutlined />}
                  className="cursor-pointer py-1 px-3 text-xs font-medium rounded-full m-0"
                >
                  {!voucherCode && !voucherValue ? "Chọn mã giảm giá" : voucherCode}
                </Tag>
                {voucherCode && voucherValue > 0 && (
                  <CloseOutlined
                    className="text-red-500 cursor-pointer text-sm ml-1 p-1 hover:bg-red-50 rounded-full transition-colors"
                    onClick={handleClearVoucher}
                  />
                )}
              </div>
            </div>
            {voucherTxt && (
              <div
                className="text-xs"
                dangerouslySetInnerHTML={{ __html: voucherTxt }}
              />
            )}
            <div className="pt-2 border-t border-gray-200 flex flex-col gap-1 text-sm">
              <div className="flex justify-between text-gray-500">
                <span>Giá cước:</span>
                <span className="font-semibold text-gray-700">
                  {(
                    (priceSelected || 0) + (voucherValue || 0)
                  ).toLocaleString("vi-VN")}{" "}
                  đ
                </span>
              </div>
              {voucherValue > 0 && (
                <div className="flex justify-between text-green-600">
                  <span>Giảm giá ({voucherCode}):</span>
                  <span className="font-semibold">
                    - {voucherValue.toLocaleString("vi-VN")} đ
                  </span>
                </div>
              )}
              <div className="flex justify-between text-base font-bold text-primary pt-1 border-t border-gray-100">
                <span>Tổng thanh toán:</span>
                <span className="text-red-600">
                  {(priceSelected || 0).toLocaleString("vi-VN")} đ
                </span>
              </div>
            </div>
          </div>
          <div className="flex justify-between gap-4 py-4">
            <Button
              color="danger"
              variant="filled"
              style={{ height: 48 }}
              onClick={handleCancel}
            >
              <span className="text-[18px] font-bold">Huỷ</span>
            </Button>
            <Button
              type="primary"
              htmlType="sumit"
              style={{ height: 48 }}
              className=" flex-1"
              loading={loading}
            >
              <span className="text-[18px] font-bold">Xác nhận đặt chuyến</span>
            </Button>
          </div>
          <div className="text-red-500 mt-0">
            Quý khách sẽ tiến hành thanh toán sau khi đặt chuyến!
          </div>
        </Form>
      </Modal>
      <Modal
        title="Thông báo"
        open={isModalNoPriceOpen}
        width="100%"
        onCancel={() => setIsModalNoPriceOpen(false)}
        footer={null}
      >
        <div className="text-[14px] font-semibold text-[16px]">
          Để được hỗ trợ nhanh nhất, quý khách vui lòng bấm gọi hotline.
          <br />
          Cảm ơn quý khách đã tin tưởng và sử dụng dịch vụ của Xe VIP Nội Bài!
        </div>
        <div className="w-full text-center my-4">
          <Button
            type="primary"
            htmlType="sumit"
            style={{ height: 48 }}
            className=" bg-primary flex-1"
          >
            <a className="text-[18px] font-bold" href="tel:1900888697">
              Hotline: 0876.100.800
            </a>
          </Button>
        </div>
      </Modal>

      {/* Voucher Drawer */}
      <Drawer
        title={
          <div className="flex flex-col gap-3">
            <div className="flex justify-between items-center">
              <span className="uppercase font-bold text-base text-gray-800">
                Mã giảm giá
              </span>
              <CloseOutlined
                onClick={() => setOpenVoucher(false)}
                className="text-gray-500 hover:text-gray-800 text-lg cursor-pointer"
              />
            </div>
            <div>
              <Space.Compact style={{ width: "100%", display: "flex" }}>
                <Input
                  placeholder="Nhập mã giảm giá khác..."
                  allowClear
                  value={manualVoucherCode}
                  onChange={(e) => {
                    setManualVoucherCode(e.target.value);
                    if (voucherTxt) setVoucherTxt("");
                  }}
                  onPressEnter={() => applyManualVoucher(manualVoucherCode)}
                  className="h-10 text-sm"
                  style={{ flex: 1 }}
                />
                <Button
                  type="primary"
                  className="!bg-primary text-white font-medium h-10 px-5 flex-shrink-0"
                  style={{
                    backgroundColor: "#3F7BF3",
                    borderColor: "#3F7BF3",
                    color: "#ffffff",
                  }}
                  loading={loadingManualVoucher}
                  onClick={() => applyManualVoucher(manualVoucherCode)}
                >
                  Áp dụng
                </Button>
              </Space.Compact>
              {voucherTxt && (
                <div
                  className="mt-2 text-xs"
                  dangerouslySetInnerHTML={{ __html: voucherTxt }}
                />
              )}
            </div>
          </div>
        }
        placement="bottom"
        closable={false}
        onClose={() => setOpenVoucher(false)}
        open={openVoucher}
        height="80%"
        bodyStyle={{
          background: "#f8fafc",
          padding: "16px",
        }}
      >
        <div className="flex flex-col gap-3">
          {loadingVouchers ? (
            <div className="py-12 flex flex-col items-center justify-center gap-2 text-gray-400">
              <Spin />
              <span className="text-sm">Đang tải mã giảm giá...</span>
            </div>
          ) : vouchers.length === 0 ? (
            <div className="py-12 text-center text-gray-400 text-sm">
              Không có mã giảm giá khả dụng
            </div>
          ) : (
            vouchers.map((voucher, idx) => {
              const code = voucher.code || `VOUCHER_${idx}`;
              const amount = Number(voucher.amount) || 0;
              const expiredAt = voucher.expiredAt;

              return (
                <div
                  key={voucher.id || code}
                  className="rounded-xl bg-white p-3.5 shadow-sm border border-gray-100 flex gap-3 items-center hover:border-blue-200 transition-colors"
                >
                  <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
                    <img
                      src="/images/ic-voucher.svg"
                      className="w-6 h-6 object-contain"
                      alt="Voucher"
                    />
                  </div>
                  <div className="flex flex-col flex-1 min-w-0">
                    <div className="font-bold text-sm text-primary truncate">
                      Mã: {code}
                    </div>
                    {amount > 0 && (
                      <div className="text-red-500 text-xs font-semibold mt-0.5">
                        Giảm {amount.toLocaleString("vi-VN")} đ
                      </div>
                    )}
                    {expiredAt && (
                      <div className="text-gray-400 text-[11px] mt-1">
                        HSD: {moment(expiredAt).format("DD/MM/YYYY HH:mm")}
                      </div>
                    )}
                  </div>
                  <Button
                    type="primary"
                    size="small"
                    className="!bg-primary text-white font-medium shrink-0 rounded-lg text-xs"
                    style={{
                      backgroundColor: "#3F7BF3",
                      borderColor: "#3F7BF3",
                      color: "#ffffff",
                    }}
                    onClick={() => applyVoucherPick(voucher)}
                  >
                    Áp dụng
                  </Button>
                </div>
              );
            })
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default Booking;
